import React from 'react';
import { Flag } from 'lucide-react';
import { Select, Group, Text } from '@mantine/core';

interface PriorityDropdownProps {
  value: 'Low' | 'Medium' | 'High';
  onChange: (value: 'Low' | 'Medium' | 'High') => void;
  id?: string;
}

const priorityOptions = [
  { value: 'Low' as const, label: 'Low Priority', color: 'var(--app-text-secondary)' },
  { value: 'Medium' as const, label: 'Medium Priority', color: '#f59e0b' },
  { value: 'High' as const, label: 'High Priority', color: '#ef4444' }
];

export const PriorityDropdown: React.FC<PriorityDropdownProps> = ({ value, onChange, id }) => {
  const selectedOption = priorityOptions.find(opt => opt.value === value) || priorityOptions[1];

  const selectData = priorityOptions.map(option => ({
    value: option.value,
    label: option.label
  }));

  return (
    <Select
      id={id}
      data={selectData}
      value={value}
      onChange={(val) => val && onChange(val as 'Low' | 'Medium' | 'High')}
      leftSection={<Flag size={16} style={{ color: selectedOption.color }} />}
      renderOption={({ option }) => {
        const optionData = priorityOptions.find(opt => opt.value === option.value);
        return (
          <Group gap="xs">
            <Flag size={16} style={{ color: optionData?.color }} />
            <Text c="var(--app-text-primary)">{option.label}</Text>
          </Group>
        );
      }}
      placeholder="Select priority"
      size="sm"
      radius="md"
    />
  );
};
